/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
/* eslint-disable prettier/prettier */
import t from "./types";
import apiType from "../APIResponseActions/type";
import { AuthAPI } from "../../../Auth/requestHandler";

export const getQuickPermitLot = (property_id) => async (dispatch) => {
  try {
    await dispatch({
      type: apiType.API_RESPONSE_SUCCESS,
      payload: "",
    });

    const url = `lot/quick-permit/${property_id}`;
    const response = await AuthAPI("domain", url, "GET");

    if (response?.success) {
      await dispatch({
        type: t.GET_QUICK_PERMIT_LOT,
        payload: response.data,
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.message || "",
      });
    } else {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: response.message,
      });
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};